// https://www.codeforest.net/html5-image-upload-resize-and-crop
export const fileResize = (file, maxWidth = 1024, maxHeight = 1024, required = null, requiredType) => {
    return new Promise((resolve, reject) => {
        var reader = new FileReader();
        reader.onload = e => {
            var img = document.createElement('img');
            img.onload = () => {
                var canvas = document.createElement('canvas');
                var ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0);
                // -1 indicates we want to use image's original width
                var MAX_WIDTH = maxWidth === -1 ? img.width : maxWidth;
                // -1 indicates we want to use image's original width
                var MAX_HEIGHT = maxHeight === -1 ? img.height : maxHeight;
                var width = img.width;
                var height = img.height;
                if (requiredType) {
                    if (!(file.type === requiredType)) {
                        reject('NOPE!');
                    }
                }
                if (required) {
                    if (!(width === required.width && height === required.height)) {
                        reject('NOPE!');
                    }
                }
                if (width > height) {
                    if (width > MAX_WIDTH) {
                        height *= MAX_WIDTH / width;
                        width = MAX_WIDTH;
                    }
                } else {
                    if (height > MAX_HEIGHT) {
                        width *= MAX_HEIGHT / height;
                        height = MAX_HEIGHT;
                    }
                }
                canvas.width = width;
                canvas.height = height;
                ctx = canvas.getContext('2d');
                ctx.drawImage(img, 0, 0, width, height);
                var dataurl = canvas.toDataURL(file.type);
                resolve(dataurl);
            };
            img.src = e.target.result;
        };
        reader.readAsDataURL(file);
    });
};
